enum TokenType {
    TENANT = 0,
    KFLEET = 1,
}

export default TokenType;